// import { monthnameslong } from 'components/main/main.component'
import React from 'react'
import styled from 'styled-components'

const isMobile = window.innerWidth < 600

const StyledCard = styled.div<{
  checked_: boolean
  hasSeason: boolean
}>`
  font-family: var(--font-plex);
  /* flex: ${isMobile ? '0 1 calc(50% - 4px)' : '0 1 calc(25% - 6px)'}; */
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${({ checked_, hasSeason }) =>
    hasSeason
      ? checked_
        ? 'var(--beige-bright-2)'
        : 'var(--beige-bright-2)'
      : 'var(--gray-bright-3)'};

  text-align: center;
  line-height: 1.4em;
  position: relative;

  /* &:hover {
    cursor: pointer;
    opacity: 0.7;
  } */
  img {
    /* max-width: ${isMobile ? '70px' : '80px'}; */
    padding-bottom: 0px;
  }
  height: 100%;
`

const Name = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 1.3em;
  flex: 0 0 100%;
  font-weight: 400;
  letter-spacing: 0.2px;
`

const BottomBackground = styled.div<{ checked_: boolean; hasSeason: boolean }>`
  width: 100%;
  position: relative;
  padding-top: 5px;
  padding-bottom: 10px;
  gap: 0;
  line-height: 1em;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  @media only screen and (max-width: 711px) {
    padding-top: 10px;
  }
`
const ContentContainer = styled.div`
  width: 100%;
  position: relative;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: column;
  gap: 0;
  justify-content: flex-end;
  padding-top: 15px;
`

const IlluFrame = styled.div<{ hasSeason: boolean }>`
  width: 100%;
  /* padding-top: 5px; */
  flex: 1 1 auto;
  img {
    width: 30%;

    opacity: ${({ hasSeason }) => (!hasSeason ? 1 : 1)};
    -webkit-filter: ${({ hasSeason }) =>
      !hasSeason ? 'grayscale(70%)' : undefined};
    filter: ${({ hasSeason }) => (!hasSeason ? 'grayscale(70%)' : undefined)};
  }
`

export const Card = ({
  data,
  hasSeason,
  lang
}: {
  data: FruitElementType
  hasSeason: boolean
  lang: 'de' | 'fr'
}) => {
  const {
    bez,
    bez_fr,
    checked,
    checkedAndAvailable,

    activeColor,
    imageid
  } = data

  const container = React.useRef(null)
  const checked_ = activeColor
    ? !isNaN(Date.parse(checked || '')) && checkedAndAvailable
    : false

  const getIllustration = (imageid: string, size: string = 'k') => {
    let defaultId = 'placeholder'
    try {
      
      return require('../Illus/' + imageid + '-' + size + '.png')
    } catch (e) {
      console.log(e)
      return require('../Illus/' + defaultId + '-' + size + '.png')
    }
  }

  return (
    <StyledCard ref={container} checked_={true} hasSeason={hasSeason}>
      <ContentContainer className='ContentContainer'>
        <IlluFrame hasSeason={hasSeason}>
          <img src={getIllustration(imageid)} alt='' />
        </IlluFrame>
      </ContentContainer>
      <BottomBackground checked_={checked_} hasSeason={hasSeason}>
        <Name>{lang === 'de' ? bez : bez_fr}</Name>
      </BottomBackground>
    </StyledCard>
  )
}
